import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getPendingDispatches } from '../../api/warehouseApi';
import { normalizePaginatedResponse } from '../../utils/pagination';
import InlineLoading from '../InlineLoading';

export default function DispatchTransfersPanel({ branchId, refreshKey }) {
  const [page, setPage] = useState(1);
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState({ loading: true });
  useEffect(() => {
    let active = true;
    setState({ loading: true });
    getPendingDispatches(branchId, page).then(response => {
      if (active) setState({ ...normalizePaginatedResponse(response), loading: false });
    }).catch(() => { if (active) setState({ error: true, loading: false }); });
    return () => { active = false; };
  }, [branchId, page, refreshKey, attempt]);
  return <section className="rounded-xl border border-slate-200 bg-white p-4" aria-label="Traslados pendientes">
    <h2 className="font-semibold text-slate-900">Carga y recepción de traslados</h2>
    {state.loading ? <InlineLoading label="Cargando traslados" /> : state.error ? <p role="alert">No se pudieron cargar los traslados. <button className="min-h-11 text-blue-700 underline" onClick={() => setAttempt(value => value + 1)}>Reintentar</button></p>
      : <><div className="divide-y">{state.data.map(guide => {
        const origin = String(guide.sourceBranchId) === String(branchId);
        const actionable = origin ? guide.status === 'pending_loading' : guide.status === 'in_transit';
        const label = origin ? guide.status === 'pending_loading' ? 'Verificar carga' : 'Esperando recepción'
          : guide.status === 'in_transit' ? 'Verificar recepción' : 'Esperando carga';
        return <div key={guide.id} className="flex flex-wrap items-center justify-between gap-3 py-3 text-sm">
          <div><strong>Traslado #{guide.id}</strong><p className="text-slate-600">{guide.SourceBranch.branchName} → {guide.DestinationBranch.branchName}</p></div>
          <Link className={`inline-flex min-h-11 items-center rounded-lg px-3 font-semibold ${actionable ? 'bg-blue-600 text-white' : 'bg-slate-100 text-slate-700'}`}
            to={`/branches/${branchId}/delivery-guides/${guide.id}/details`}>{label}</Link>
        </div>;
      })}</div>{!state.data.length && <p className="mt-2 text-sm text-slate-500">No hay traslados pendientes.</p>}
      {state.totalPages > 1 && <div className="flex items-center justify-end gap-4 text-sm"><button disabled={page <= 1} className="min-h-11 disabled:opacity-40" onClick={() => setPage(value => value - 1)}>Anterior</button><span>{page} / {state.totalPages}</span><button disabled={!state.hasNext} className="min-h-11 disabled:opacity-40" onClick={() => setPage(value => value + 1)}>Siguiente</button></div>}</>}
  </section>;
}
